export const CODEX_LINE_HEIGHT = 18;
